module.exports = __webpack_public_path__ + "static/media/trainVideo7.3e152c77.mp4";